import { apiService } from "@/_services";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import { userPool } from "@/_helpers/cognitoConfig";
import Vue from "vue";
import gql from "graphql-tag";

const user = JSON.parse(localStorage.getItem("user"));

const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const actions = {
  async login({ dispatch, commit }, ctx) {
    if (this.source === "cognito") {
      commit("loginRequest");

      return new Promise((resolve, reject) => {
        const user = new CognitoUser({
          Username: ctx.username,
          Pool: userPool
        });

        const authDetails = new AuthenticationDetails({
          Username: ctx.username,
          Password: ctx.password
        });

        user.authenticateUser(authDetails, {
          onSuccess: session => {
            const idToken = session.getIdToken().getJwtToken();
            const refreshToken = session.getRefreshToken().getToken();

            commit("loginSuccess", { access: idToken, refresh: refreshToken });
            dispatch("alert/success", "Success", { root: true });

            resolve({ access: idToken, refresh: refreshToken });
          },
          onFailure: err => {
            commit("loginFailure");
            dispatch("alert/error", err.message, { root: true });
            reject(err);
          }
        });
      });
    } else {
      // await apiService.login(username, password)
      await ctx.$apollo
        .mutate({
          mutation: gql`
            mutation($username: String!, $password: String!, $refresh: String) {
              login(username: $username, password: $password, refresh: $refresh)
            }
          `,
          variables: {
            username: ctx.username,
            password: ctx.password,
            refresh: Date().toLocaleString()
          }
        })
        .then(
          data => {
            data = data["data"]["login"];
            commit("loginSuccess", data);
            dispatch("alert/success", "Success", { root: true });
            return data;
          },
          error => {
            this.ValError = true;
            error = error.graphQLErrors[0].extensions.response.body.detail;
            commit("loginFailure", error);
            dispatch("alert/error", error, { root: true });
          }
        );
    }
  },

  /**
   * Login with Google
   */
  async googleLogin({ commit, dispatch }, response) {
    try {
      const googleIdToken = response;
      commit("loginSuccess", { access: googleIdToken, refresh: null });
      dispatch("alert/success", "Login with Google successful", { root: true });
    } catch (error) {
      console.error("Error en Google Login:", error);
      dispatch("alert/error", "Error logging in with Google", { root: true });
    }
  },
  async microsoftLogin({ commit, dispatch }, idToken) {
    try {
      commit("loginSuccess", { access: idToken, refresh: null });
      dispatch("alert/success", "Login with Microsoft successful", {
        root: true
      });
    } catch (error) {
      commit("loginFailure");
      dispatch("alert/error", "Error logging in with Microsoft", {
        root: true
      });
      throw error;
    }
  },
  /**
   * Logout
   * @param {*} param0
   */

  logout({ commit }) {
    apiService.logout();
    commit("logout");
  },

  /**
   * Adding new user
   * @param {} param0
   * @param {*} user
   */
  async register({ dispatch, commit }, user) {
    commit("registerRequest", user);
    await apiService.register(user).then(
      user => {
        if (
          user.message === "User registered. Verify your email to continue."
        ) {
          commit("registerSuccess", user);
          dispatch(
            "alert/success",
            "Account created. We will contact you to activate your account",
            {
              root: true
            }
          );
        } else {
          let message = "";
          if (user !== undefined) {
            Object.keys(user).forEach(function(key) {
              if (key === "email" || key === "username") {
                message += " " + user[key];
              }
            });
          }
          if (user.data !== undefined) {
            Object.keys(user).forEach(function(key) {
              if (key === "data") {
                Object.keys(user[key]).forEach(function(keyy) {
                  message += " " + user[key][keyy];
                });
              }
            });
          }
          /**/
          dispatch("alert/error", message, { root: true });
        }
        //router.push('/login');
      },
      error => {
        commit("registerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  }
};
const mutations = {
  loginRequest(state) {
    state.status = { loggingIn: true };
    state.user = null;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    Vue.set(state, "user", user);
    localStorage.setItem("token", user.access);
    localStorage.setItem("refresh", user.refresh);
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.user = null;
    state.status = {};
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
  },
  registerRequest(state) {
    state.status = { registering: true };
  },
  registerSuccess(state) {
    state.status = {};
  },
  registerFailure(state) {
    state.status = {};
  }
};

export const authentication = {
  namespaced: true,
  state,
  user,
  actions,
  mutations
};
